(() => {
  if (!['holdcom.com.au', 'www.holdcom.com.au'].includes(location.hostname)) return;

  const start = () => {
    if (document.documentElement.dataset.holdcomApp !== 'true') return;
    if (window.__holdcomWebsiteAppVisibilityInstalled) return;
    window.__holdcomWebsiteAppVisibilityInstalled = true;

    document.documentElement.removeAttribute('data-holdcom-app-download-page');
    document.getElementById('holdcom-app-installed')?.remove();
    document.querySelectorAll('[data-holdcom-app-hidden]')
      .forEach(element => element.removeAttribute('data-holdcom-app-hidden'));

    const style = document.createElement('style');
    style.id = 'holdcom-app-visibility-style';
    style.textContent = `
      html[data-holdcom-app="true"] .holdcom-app-downloads__card--shopping {
        display: none !important;
      }
      html[data-holdcom-app="true"] .holdcom-app-downloads__grid {
        grid-template-columns: minmax(0, 1fr);
        max-width: 720px;
      }
    `;
    document.head.appendChild(style);
  };

  start();
  new MutationObserver(start).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-holdcom-app']
  });
})();
